// Module
var code = `<div class="sss-online-employer-payment">
  <form name="\$ctrl.commandForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Payor type:</td>
        <td>
          <select name="payorKind"
                  ng-model="\$ctrl.payorKind"
                  ng-required="true">
            <option value="INDIVIDUAL">Individual</option>
            <option value="EMPLOYER">Employer</option>
          </select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Payment Reference Number:</td>
        <td>
          <input type="text"
                 name="paymentReferenceNumber"
                 ng-change="\$ctrl.payment = null"
                 ng-model="\$ctrl.paymentReferenceNumber"/>
        </td>
        <td>
          <button
              type="button"
              class="btn btn-success"
              ng-click="\$ctrl.fetchPayment()"
              ng-disabled="!\$ctrl.paymentReferenceNumber">
            Check
          </button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Employer name:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.payorName"/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Employer number:</td>
        <td>
          <input disabled
                 type="text"
                 ui-mask="99-9999999-9"
                 ng-model="\$ctrl.payment.ssNumber"/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Employer branch code:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.branchCode"/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Amount:</td>
        <td>
          <cash ng-model="\$ctrl.payment.amount"
            ng-disabled="true"></cash>
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>Applicable month:</td>
        <td>
          <input disabled
                 type="text"
                 ng-model="\$ctrl.payment.applicableMonth"/>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
    <validator condition="\$ctrl.payment"></validator>
    <div class="buttons">
      <button
          type="button"
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.commandForm.\$pristine"
          ng-click="\$ctrl.cancelAction()">
        Cancel
      </button>
      <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.commandForm.\$invalid"
          ng-click="\$ctrl.save()">
        Submit payment
      </button>
    </div>
  </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-online-payment/sss-online-employer-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;